class Header {
  constructor($el) {
    this.$el = $el;
    this.$window = $(window);
    this.$hero = $(".hero");
    this.$navLinks = this.$el.find(".navigation__link");
    this.last = 0;
    this.hideAfter = 100;
    this.desktopBreakpoint = 992;

    this.init();
  }

  init = () => {
    this.$window.on("scroll", this.handleScroll);
    this.$window.on("resize", this.updateState);
    $(document).on("burger:close", this.updateState);
    this.$navLinks.on("click", this.handleNavClick);

    this.updateState();
  };

  isDesktop = () => {
    return window.innerWidth >= this.desktopBreakpoint;
  };

  handleNavClick = () => {
    if (!this.isDesktop()) {
      $(document).trigger("nav:close");
    }
  };

  handleScroll = () => {
    const cur = this.$window.scrollTop();

    if (this.isDesktop()) {
      this.$el.removeClass("header--hidden");
      this.updateSolid(cur);
      this.last = cur;
      return;
    }

    if ($("body").hasClass("nav--open")) {
      this.$el.removeClass("header--hidden");
      this.updateSolid(cur);
      this.last = cur;
      return;
    }

    if (cur < this.hideAfter) {
      this.$el.removeClass("header--hidden");
    } else {
      cur > this.last
        ? this.$el.addClass("header--hidden")
        : this.$el.removeClass("header--hidden");
    }

    this.updateSolid(cur);
    this.last = cur;
  };

  updateSolid = (scrollTop = this.$window.scrollTop()) => {
    if (!$thisExists(this.$hero)) {
      this.$el.addClass("header--solid");
      return;
    }

    const heroBottom = this.$hero.offset().top + this.$hero.outerHeight();
    const headerBottom = scrollTop + this.$el.outerHeight();

    if ($("body").hasClass("nav--open")) {
      this.$el.addClass("header--solid");
      return;
    }

    if (headerBottom < heroBottom) {
      this.$el.removeClass("header--solid");
    } else {
      this.$el.addClass("header--solid");
    }
  };

  updateState = () => {
    const cur = this.$window.scrollTop();

    if (this.isDesktop()) {
      this.$el.removeClass("header--hidden");
    }

    this.updateSolid(cur);
    this.last = cur;
  };
}

function $thisExists($el) {
  return $el && $el.length;
}

export default Header;
